module.exports = __webpack_public_path__ + "img/doctorstrange.54df4def.svg";